<div class="item-box" tabindex="0" (click)="OnItemBoxClick()" (keydown.enter)="OnItemBoxToggle($event)" (keydown.space)="OnItemBoxToggle($event)">
    <ng-content></ng-content>
    <ion-icon class="expand" [hidden]="IsExpand === true" name="chevron-down-outline"></ion-icon>
    <ion-icon class="expand" [hidden]="IsExpand !== true" name="chevron-up-outline"></ion-icon>
</div>
